import script from "./TransactionDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionDetailPage.vue?vue&type=style&index=0&id=5b877ccd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b877ccd"]])

export default __exports__